import { Box, Button, Heading, Spacer, Text } from '@homebotapp/hb-react-component-catalog'
import { SlideOnMount } from '../../../shared/Animations'
import { FormattedMessage, defineMessages, useIntl } from 'react-intl'
import { HomeownerDigestTrackingEventLocation } from '../../../../constants/tracking'

const Slide = props => <SlideOnMount interval={50} top='-80px' {...props} />

const MSG = defineMessages({
  subheading: {
    id: 'HomePriceIndexWizard.steps.currentAppraisalCheck.subheading',
    defaultMessage: 'If not, no worries.'
  },
  yes: {
    id: 'HomePriceIndexWizard.steps.currentAppraisalCheck.yes',
    defaultMessage: 'Yes'
  },
  no: {
    id: 'HomePriceIndexWizard.steps.currentAppraisalCheck.no',
    defaultMessage: 'No'
  }
})

export const CurrentAppraisalCheck = ({ onComplete }) => {
  const intl = useIntl()

  return (
    <Box flex='1' display='flex' flexDirection='column' justifyContent='space-between'>
      <Slide>
        <Heading fontWeight='normal' mb='2'>
          <FormattedMessage
            id='HomePriceIndexWizard.steps.currentAppraisalCheck.heading'
            defaultMessage='Have you had an appraisal since {fiveYearsAgo}?'
            values={{
              fiveYearsAgo: new Date('2018-01-01T00:00:00').getFullYear()
            }}
          />
        </Heading>
        <Text mb='0'>{intl.formatMessage(MSG.subheading)}</Text>
      </Slide>
      <Spacer />
      <Slide>
        <Button
          width='100%'
          mb='2'
          colorScheme='primary'
          onClick={e =>
            onComplete({
              hasRecentAppraisal: true
            })
          }
          tracking={{
            guid: 'tD6fS4G3Z7gUKXbAVbZ3EX',
            descriptor: MSG.yes.defaultMessage,
            ui_context:
              HomeownerDigestTrackingEventLocation.HOMEOWNER_DIGEST_HOME_PRICE_INDEX_WIZARD_CURRENT_APPRAISAL_CHECK_STEP
          }}
        >
          {intl.formatMessage(MSG.yes)}
        </Button>
      </Slide>
      <Slide>
        <Button
          width='100%'
          onClick={e => {
            onComplete({
              hasRecentAppraisal: false
            })
          }}
          tracking={{
            guid: 'bcY1sRrU3v4hjJptvG93ap',
            descriptor: MSG.no.defaultMessage,
            ui_context:
              HomeownerDigestTrackingEventLocation.HOMEOWNER_DIGEST_HOME_PRICE_INDEX_WIZARD_CURRENT_APPRAISAL_CHECK_STEP
          }}
        >
          {intl.formatMessage(MSG.no)}
        </Button>
      </Slide>
    </Box>
  )
}
